import apiCall from './call'

const model = 'flags'

const state = {
  all: [],
  count: 0
}

const getters = {
  total: state => state.count,
  all: state => state.all
}

const actions = {
  updateFlag ({ commit }, flag) {
    return new Promise((resolve, reject) => {
      apiCall({
        url: model + '/' + flag.id,
        method: 'PUT',
        data: flag.status
      })
        .then(response => {
          commit('reduceCount')
          resolve(response)
        })
        .catch(err => {
          reject(err)
        })
    })
  }
}

const mutations = {
  setFlags (state, notifications) {
    state.all = notifications
  },
  setCount (state, count) {
    if (!count) return
    state.count = count
  },
  reduceCount (state) {
    state.count = state.count--
  }
}

export default {
  namespaced: true,
  getters,
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/flags.js